// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3cIPf","rootSuccess":"CompleteLink_rootSuccess__2JTg1","rootFailure":"CompleteLink_rootFailure__2Wfva","isDisabled":"CompleteLink_isDisabled__ULogk"};